"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _ButtonLink = _interopRequireDefault(require("../../ButtonLink"));
var _Close = _interopRequireDefault(require("../../icons/Close"));
const DrawerClose = /*#__PURE__*/React.forwardRef(({
  onClick,
  title
}, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "ms-md"
  }, /*#__PURE__*/React.createElement(_ButtonLink.default, {
    onClick: onClick,
    iconLeft: /*#__PURE__*/React.createElement(_Close.default, null),
    ref: ref,
    type: "secondary",
    title: title
  }));
});
var _default = DrawerClose;
exports.default = _default;